        (function () {
          var KEY = 'bb_sub_email', PEND = 'bb_pending_email', ROUTED = 'bb_discount_routed';
          var auth = document.querySelector('.news__auth');
          var locked = document.getElementById('newsLocked');
          var wrap = document.getElementById('newsFormWrap');
          var mailEl = document.getElementById('newsLockedMail');
          if (!auth || !locked || !wrap) return;

          var serverEmail = auth.getAttribute('data-sub-email') || '';
          var posted = location.search.indexOf('customer_posted=true') !== -1;

          function showLocked(email) {
            if (!email) return;
            if (mailEl) mailEl.textContent = email;
            locked.hidden = false;
            wrap.hidden = true;
          }
          function showForm() { locked.hidden = true; wrap.hidden = false; }

          // 已登录且已订阅：服务端真值优先
          if (serverEmail) showLocked(serverEmail);

          // 提交成功：把提交前暂存的邮箱转正（失败不写，避免撒谎）
          if (posted) {
            var pending = null;
            try { pending = sessionStorage.getItem(PEND); } catch (e) {}
            if (pending) { try { localStorage.setItem(KEY, pending); } catch (e) {} }
          }

          /* NO-20-20261101：全站只有订阅 10%，已订阅态的说明就写死这一句，
             不再按档位切换（20% 首单已取消，bb_offer 只可能是 COLLECTOR5）。 */
          function paintOfferNote() {
            try {
              var el = document.querySelector('.news__locked-note');
              if (!el) return;
              if (String(localStorage.getItem('bb_offer') || '').toUpperCase() === 'COLLECTOR5') {
                el.textContent = '10% comes off every order automatically at checkout.';
              }
            } catch (e) {}
          }
          paintOfferNote();
          try { window.addEventListener('bb:identity', paintOfferNote); } catch (e) {}
          try { window.addEventListener('bb:offer', paintOfferNote); } catch (e) {}

          // 游客：localStorage 记住的订阅状态
          if (!serverEmail) {
            var saved = null;
            try { saved = localStorage.getItem(KEY); } catch (e) {}
            if (saved) showLocked(saved);
          }

          // 提交时暂存邮箱（此时还没成功，只进 sessionStorage）
          var form = document.querySelector('.news__form');
          if (form) {
            form.addEventListener('submit', function () {
              var i = document.getElementById('newsEmail');
              var em = (i && i.value ? i.value.trim() : '') || String(window.BB_CUST_EMAIL || '');
              if (i && i.value) { try { sessionStorage.setItem(PEND, i.value.trim()); } catch (e) {} }
              /* IDENTITY-20261030：订阅这份邮箱顺手把身份交给后台 ——
                 客户在底部框填一次邮箱，返利中心就已经有他的码和链接了，
                 不用再进 /pages/rewards 点一次。
                 用 beacon：这是原生表单 POST，整页跳转，普通 fetch 会被中断。 */
              if (em && window.BBIdentity) {
                try { window.BBIdentity.bind(em, { beacon: true, subscribe: false }); } catch (e) {}
              }
            });
          }

          // 换邮箱：清本地状态回到表单（不假装退订）
          var ch = document.getElementById('newsChange');
          if (ch) ch.addEventListener('click', function () {
            try { localStorage.removeItem(KEY); } catch (e) {}
            showForm();
            var i = document.getElementById('newsEmail');
            if (i) { i.value = ''; i.focus(); }
          });

          // 订阅成功回跳 -> 把 5% 写进浏览器（cookie），客户以后结账自动带
          if (posted) {
            /* IDENTITY-20261030：订阅成功回跳的收口统一在 bb-identity.js（全站一份），
               这里不再重复调 —— 否则每页打两次 Shopify consent 查询。 */
            var once = false;
            try { once = sessionStorage.getItem(ROUTED) === '1'; } catch (e) {}
            if (!once) {
              try { sessionStorage.setItem(ROUTED, '1'); } catch (e) {}
              /* 🔴 DISCOUNT-PICK-20261023：订阅成功时如果这个人是被朋友分享进来的，
                 直接升到 FRIEND15（朋友 10% + 订阅 5%），别把他降回只有 5%。
                 这里不能用 BB_PICK_DISCOUNT() —— 此刻 bb_collector 还没写（brand.js 随后才 mark），
                 但「能走到这一行」本身就等于订阅成功，所以只看有没有 ref。 */
              /* DISCOUNT-UNIFY-20261031：订阅成功的 10% 由自动折扣直接生效，
                 不再写折扣 cookie、也不再跳 /discount/COLLECTOR5。 */
            }
          }
        })();

        /* ============================================================================
           NEWS-SHEET-20261103（侯哥 11-03 12:02 两张截图）
           「订阅说明直接做到订阅卡里面的弹窗里，这样更协调，看起来更美观和便捷」
           首页不再有第四屏那块订阅横幅 ⇒ 点订阅卡 / 导航 Join / 任何 /#join 链接 = 弹窗。
           · 三态渲染仍归上面那段（本文件上半部分，元素 id/class 一个没动）
           · 这里只管开关：点链接开；点遮罩 / × / ESC / 浏览器后退关
           · 深链 #join 仍有效（老链接、分享链接全不作废）
           ============================================================================ */
        (function () {
          var sheet = document.getElementById('newsSheet');
          if (!sheet) return;
          var panel = sheet.querySelector('.nsheet__panel');
          var lastFocus = null, timer = null, open = false;

          function bodyLock() {
            try {
              document.body.classList.add('locked');
              document.body.classList.add('news-open');
            } catch (e) {}
          }
          function bodyUnlock() {
            try {
              document.body.classList.remove('news-open');
              /* locked 是和抽屉/看货器共用的：别的层还开着就别解锁（同 closeSheet 口径） */
              if (!document.body.classList.contains('drawer-open') &&
                  !document.body.classList.contains('reels-open')) {
                document.body.classList.remove('locked');
              }
            } catch (e) {}
          }

          function show(push) {
            if (open) return;
            open = true;
            lastFocus = document.activeElement;
            clearTimeout(timer);
            sheet.hidden = false;
            sheet.setAttribute('aria-hidden', 'false');
            bodyLock();
            /* 双 rAF：先让元素进布局，再加 .is-open，过渡才有起点（直接加会是 0 帧跳变） */
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { sheet.classList.add('is-open'); });
            });
            if (push !== false) {
              try { history.pushState({ bbNews: 1 }, '', '#join'); } catch (e) {}
            }
            setTimeout(function () {
              /* 先盯输入框、没有才退到关闭键（querySelector 按文档顺序取，× 排在输入框前面，
                 写成逗号并集会永远聚焦到 × —— 实测踩过） */
              var f = panel.querySelector('input:not([type=hidden]):not([disabled])') ||
                      panel.querySelector('.nsheet__x');
              if (f && f.focus) { try { f.focus({ preventScroll: true }); } catch (e) { try { f.focus(); } catch (e2) {} } }
            }, 280);
          }

          function hide(fromPop) {
            if (!open) return;
            open = false;
            sheet.classList.remove('is-open');
            sheet.setAttribute('aria-hidden', 'true');
            bodyUnlock();
            clearTimeout(timer);
            timer = setTimeout(function () { sheet.hidden = true; }, 300);
            if (!fromPop) {
              if (history.state && history.state.bbNews) { try { history.back(); } catch (e) {} }
              else if (location.hash === '#join') {
                try { history.replaceState(history.state, '', location.pathname + location.search); } catch (e) {}
              }
            }
            if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
          }

          window.BBNews = { open: function () { show(); }, close: function () { hide(); } };

          /* 1) 入口：订阅卡 / 导航 Join / 空状态页 —— 全是 href="/#join"，本页有弹窗就拦下来 */
          document.addEventListener('click', function (e) {
            var t = e.target;
            while (t && t !== document) {
              if (t.tagName === 'A' && /#join$/.test(t.getAttribute('href') || '')) {
                e.preventDefault();
                show();
                return;
              }
              t = t.parentNode;
            }
          }, false);

          /* 2) 关闭：遮罩 / × */
          sheet.addEventListener('click', function (e) {
            var t = e.target;
            while (t && t !== sheet) {
              if (t.hasAttribute && t.hasAttribute('data-news-close')) { hide(); return; }
              t = t.parentNode;
            }
          });

          /* 3) ESC */
          document.addEventListener('keydown', function (e) {
            if (!open) return;
            if (e.key === 'Escape' || e.keyCode === 27) { e.preventDefault(); hide(); }
          });

          /* 4) 焦点圈在弹窗内（aria-modal 要对得上，Tab 不能跑到底下的页面） */
          panel.addEventListener('keydown', function (e) {
            if (e.key !== 'Tab') return;
            var f = panel.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled])');
            if (!f.length) return;
            var first = f[0], last = f[f.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
          });

          /* 5) hash 同步：粘 /#join、浏览器后退 */
          function syncHash() {
            var want = location.hash === '#join';
            if (want && !open) show(false);
            else if (!want && open) hide(true);
          }
          window.addEventListener('hashchange', syncHash);
          window.addEventListener('popstate', syncHash);

          /* 6) 首屏：深链 #join，或刚提交完订阅（整页跳回 / 时 hash 已丢，只能靠 customer_posted 认） */
          var posted = location.search.indexOf('customer_posted=true') !== -1;
          if (location.hash === '#join' || posted) {
            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', function () { show(false); });
            } else { show(false); }
          }
        })();
      
